import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'booth',
    serviceName: 'shopadmin',
    query: gql`
      query booth(
        $ids: [String]
        $title: String
        $shop_ids: [String]
        $user_id: String
        $fee_type_ids: [String]
        $codes: [String]
        $is_active: Int
        $is_default: Int
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        booth(
          ids: $ids
          title: $title
          shop_ids: $shop_ids
          user_id: $user_id
          fee_type_ids: $fee_type_ids
          codes: $codes
          is_active: $is_active
          is_default: $is_default
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          total
          last_page
          data {
            id
            title
            shop {
              title
            }
            media {
              full_url
            }
            owner {
              lastname
              firstname
            }
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteBooth',
    serviceName: 'shopadmin',
    query: gql`
      mutation deleteBooth($ids: [String]!) {
        deleteBooth(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'booth',
    serviceName: 'shopadmin',
    query: gql`
      query booth($ids: [String]) {
        booth(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'booth',
    serviceName: 'shopadmin',
    query: gql`
      query booth($ids: [String]) {
        booth(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
